export const HOME_PAGE_SECTION_HASHES = new Set([
    '#HomePage-community-section',
    '#HomePage-contact-faq-section',
]);

export function isHomePageSectionHash(hash) {
    return HOME_PAGE_SECTION_HASHES.has(hash);
}

export function scrollToHomePageSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (!section) return false;

    const html = document.documentElement;
    const previousScrollBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    const headerOffset = parseInt(
        getComputedStyle(html).getPropertyValue('--msv-app-header-offset'),
        10,
    ) || 60;

    const top = Math.max(0, section.getBoundingClientRect().top + window.scrollY - headerOffset);
    window.scrollTo({ top, behavior: 'auto' });
    html.scrollTop = top;
    document.body.scrollTop = top;

    html.style.scrollBehavior = previousScrollBehavior;
    return true;
}

export function scrollToHomePageHash(hash) {
    if (!isHomePageSectionHash(hash)) return false;
    return scrollToHomePageSection(hash.slice(1));
}
